// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__q2jK-","close":"style_close__QZEtK","description":"style_description__5g0nl","header":"style_header__7JSNM","btn":"style_btn__kdC9C"};